import { Lookup } from '../../../../shared-components/lookup/lookup.model';


export class AttendanceHistoryByClassReport {
  SiteSectionId: number;
  DistrictSubjectId: number;
  TermDescription: string;
  Course: string;
  StartPeriod: number;
  SubjectTitle: string;
  TeacherName: string;
  RoomNumber: string;
  StudentCount: number;
  Selected = false;
}

// export enum ShowTotalHoursOption {
//   IncludeAllAbsences = 0,
//   IncludeSelectedAbsences = 1,
// }

// export enum PeriodsToTallyOption {
//   OnlyPeriodsforEachSection = 0,
//   AllPeriodsForEachStudent = 1,
// }

export class ReportParameters {

  // enum  showTotalHoursSelection {
  //   includeAllAbsences,
  //   }

  // select on history dates
  SelectHistoryDates: boolean;
  HistoryFrom: Date;
  HistoryTo: Date; // string; // Date;

  // select on residency codes
  SelectResidencyCodes: boolean;
  ResidencyCodeFrom: string;              // pub_strResidencyCodeFrom
  ResidencyCodeTo: string;                // pub_strResidencyCodeTo
  ResidencyCodes: Lookup[] = [];

  // select on category codes
  SelectCategoryCodes: boolean;
  CategoryCodes: Lookup[] = [];
  CategoryCodeFrom: string;               // pub_strCategoryCodeFrom
  CategoryCodeTo: string;                 // pub_strCategoryCodeTo

  // select on grade levels
  SelectGradeLevels: boolean;
  // pub_strGradeLevelRankFrom
  // pub_strGradeLevelRankTo
  GradeLevels: Lookup[] = [];
  GradeLevelFrom: string;
  GradeLevelTo: string;

  GradeLevelRankFrom: string;
  GradeLevelRankTo: string;

  AttendanceCodes: Lookup[] = [];

  // history codes to tally
  HistoryCodesToTally: string;                // pub_strHistoryCodesToTally

  // show total hours
  // ShowTotalHours: number;
  // IncludeAbsences: string;
  IncludeAllAbsences: boolean;
  IncludeSelectedAbsences: boolean;

  HistoryMinMax: boolean;


  // periods to tally
  TallyTardies: boolean;
  // PeriodsToTally: number;
  HistoryCountMin: string; // number;
  HistoryCountMax: string; // number;

  OnlyPeriodsforEachSection: boolean;

  Count1Day: boolean;
  SplitABDays: boolean;



  // tally tardies

  // days (full/half) select codes
  // pub_strDayFullHalfCode

  DaysFullHalf: boolean;
  FullDay: boolean;
  HalfDay: boolean;

  // todays current codes tally

  CurrentMinMax: boolean;
  CurrentCodesTallyCountMin: string; // number;
  CurrentCodesTallyCountMax: string; // number;

  TodaysCurrentTally: boolean; // pub_blnTodaysCurrentTally = this.reportParameters.TodaysCurrentTally;
  DaysCodes: string;

  DaysCountMin: string; // number;
  DaysCountMax: string; // number;




  // checkboxes
  DoubleSpaceAfterStudentName: boolean;
  ShowHistoryRecords: boolean;
  ShowOnlySelectedRecords: boolean;
  ShowComments: boolean;
  IgnoreAttendance: boolean;

}

export class AttendanceHistoryByStudentPreferences {
  // pub_intReportType: number;
  // pub_blnParentInfo: boolean;
  // pub_strStudentSelectionStatus: string;
  // pub_blnSelectHistoryDates: boolean;
  // pub_datHistoryFrom: Date;
  // pub_datHistoryTo: Date;
  // pub_blnSelectResidencyCodes: boolean;
  // pub_strResidencyCodeFrom: string;
  // pub_strResidencyCodeTo: string;
  // pub_blnSelectCategoryCodes: boolean;
  // pub_strCategoryCodeFrom: string;
  // pub_strCategoryCodeTo: string;
  // pub_blnSelectGradeLevels: boolean;
  // pub_strGradeLevelRankFrom: string;
  // pub_strGradeLevelRankTo: string;
  // pub_strHistoryCodesToTallyIds: string;
  // pub_strHistoryCodesToTally: string;
  // pub_blnCount1PerDay: boolean;
  // pub_blnSplitABDays: boolean;
  // pub_strHistoryPeriodsToTally: string;
  // pub_blnOnlyPeriodsforEachSection: boolean;
  // pub_blnSelectHistoryCountMinMax: boolean;
  // pub_intHistoryCountMin: number;
  // pub_intHistoryCountMax: number;
  // pub_blnTallyTardies: boolean;
  // pub_strTallyTardiesCodesIds: string;
  // pub_strTallyTardiesCodes: string;
  // pub_blnDaysFullHalfSelect: boolean;
  // pub_blnFullDay: boolean;
  // pub_blnHalfDay: boolean;
  // pub_strDayFullHalfCode: string;
  // pub_intDaysCountMin: number;
  // pub_intDaysCountMax: number;
  // pub_blnTodaysCurrentTally: boolean;
  // pub_strTodaysCodesToTallyIds: string;
  // pub_strTodaysCodesToTally: string;
  // pub_blnCurrentMinMax: boolean;
  // pub_intCurrentCodesTallyCountMin: number;
  // pub_intCurrentCodesTallyCountMax: number;
  // pub_blnDoubleSpaceAfterStudentName: boolean;
  // pub_blnShowHistoryRecords: boolean;
  // pub_blnShowOnlySelectedRecords: boolean;
  // pub_blnShowComments: boolean;
  // pub_blnShowCurrentAtndSteps: boolean;
  // pub_blnIgnoreAttendance: boolean;
  // pub_blnNotEnrolled: boolean;
  // pub_blnIncludeAllAbsences: boolean;
  // pub_blnConsecutiveDays: boolean;

  pub_intReportType: number;
  pub_strStudentSelectionStatus: string;
  pub_blnSelectHistoryDates: boolean;
  pub_datHistoryTo:  Date;
  pub_blnSelectResidencyCodes: boolean;
  pub_strResidencyCodeFrom: string;
  pub_strResidencyCodeTo: string;
  pub_blnSelectCategoryCodes: boolean;
  pub_strCategoryCodeFrom: string;
  pub_strCategoryCodeTo: string;
  pub_blnSelectGradeLevels: boolean;
  pub_strGradeLevelRankFrom: string;
  pub_strGradeLevelRankTo: string;
  pub_blnSplitABDays: boolean;
  pub_blnOnlyPeriodsforEachSection: boolean;
  pub_blnSelectHistoryCountMinMax: boolean;
  pub_intHistoryCountMin: string; // number;
  pub_intHistoryCountMax: string; // number;
  pub_blnTallyTardies: boolean;
  pub_blnDaysFullHalfSelect: boolean;
  pub_blnFullDay: boolean;
  pub_blnHalfDay: boolean;
  pub_intDaysCountMin: string; // number;
  pub_intDaysCountMax: string; // number;
  pub_blnTodaysCurrentTally: boolean;
  pub_blnCurrentMinMax: boolean;
  pub_intCurrentCodesTallyCountMin = '1';
  pub_intCurrentCodesTallyCountMax = '999';
  pub_blnDoubleSpaceAfterStudentName: boolean;
  pub_blnShowHistoryRecords: boolean;
  pub_blnShowOnlySelectedRecords: boolean;
  pub_blnShowComments: boolean;
  pub_blnShowCurrentAtndSteps: boolean;
  pub_blnNotEnrolled: boolean;
  pub_blnIncludeAllAbsences: boolean;
  pub_blnParentInfo: boolean;
  pub_blnCount1PerDay: boolean;
  pub_strHistoryCodesToTally: string;
  pub_strTallyTardiesCodes: string;
  pub_strTodaysCodesToTally: string;
  pub_strDayFullHalfCode: string;
  pub_strReportTitle: string;

  //  NOT IN USER PREFERENCES DTO
  pub_datHistoryFrom: Date;
  pub_strTallyTardiesCodesIds: string;
  pub_strHistoryCodesToTallyIds: string;
  pub_strTodaysCodesToTallyIds: string;
  pub_blnIgnoreAttendance: boolean;
  pub_strHistoryPeriodsToTally: string;
  pub_blnConsecutiveDays: boolean;
}

/*

OnlyPeriodsforEachSection

historyCodesToTallyIds
historyCodesToTally
tallyTardiesCodesIds
tallyTardiesCodes
dayFullHalfCode

todayCodesToTallyIds
todayCodesToTally

 pub_intReportType = this.Report.ReportType;
 pub_blnParentInfo = false;
 pub_strStudentSelectionStatus = 'Active';
 pub_blnSelectHistoryDates = this.reportParameters.SelectHistoryDates;
 pub_datHistoryFrom = this.reportParameters.HistoryFrom
 pub_datHistoryTo = this.reportParameters.HistoryTo
 pub_blnSelectResidencyCodes = this.reportParameters.SelectResidencyCodes
 pub_strResidencyCodeFrom = this.reportParameters.ResidencyCodeFrom
 pub_strResidencyCodeTo = this.reportParameters.ResidencyCodeTo
 pub_blnSelectCategoryCodes = this.reportParameters.SelectCategoryCodes
 pub_strCategoryCodeFrom = this.reportParameters.CategoryCodeFrom
 pub_strCategoryCodeTo = this.reportParameters.CategoryCodeTo
 pub_blnSelectGradeLevels = this.reportParameters.SelectGradeLevels
 pub_strGradeLevelRankFrom = this.reportParameters.GradeLevelRankFrom
 pub_strGradeLevelRankTo = this.reportParameters.GradeLevelRankTo
 pub_strHistoryCodesToTallyIds = this.historyCodesToTallyIds;
 pub_strHistoryCodesToTally = this.historyCodesToTally;

 pub_blnCount1PerDay = this.reportParameters.Count1Day;
 pub_blnSplitABDays = this.reportParameters.SplitABDays;
 pub_strHistoryPeriodsToTally = "";
 pub_blnOnlyPeriodsforEachSection = this.reportParameters.OnlyPeriodsforEachSection;

 pub_blnSelectHistoryCountMinMax = this.reportParameters.HistoryMinMax;
 pub_intHistoryCountMin = this.reportParameters.SelectHistoryCountMin;
 pub_intHistoryCountMax = this.reportParameters.SelectHistoryCountMax;

 pub_blnTallyTardies = this.reportParameters.TallyTardies;
 pub_strTallyTardiesCodesIds = this.tallyTardiesCodesIds;
 pub_strTallyTardiesCodes = this.tallyTardiesCodes;

 pub_blnDaysFullHalfSelect = this.reportParameters.DaysFullHalf;
 pub_blnFullDay = this.reportParameters.FullDay;
 pub_blnHalfDay = this.reportParameters.HalfDay;
 pub_strDayFullHalfCode = dayFullHalfCode;
 pub_intDaysCountMin = this.reportParameters.DaysCountMin;
 pub_intDaysCountMax = this.reportParameters.DaysCountMax;
 pub_blnTodaysCurrentTally = this.reportParameters.TodaysCurrentTally;
 pub_strTodaysCodesToTallyIds = todayCodesToTallyIds;
 pub_strTodaysCodesToTally = todayCodesToTally;
 pub_blnCurrentMinMax = this.reportParameters.CurrentMinMax;
 pub_intCurrentCodesTallyCountMin = this.reportParameters.CurrentCodesTallyCountMin;
 pub_intCurrentCodesTallyCountMax = this.reportParameters.CurrentCodesTallyCountMax;
 pub_blnDoubleSpaceAfterStudentName = this.reportParameters.DoubleSpaceAfterStudentName
 pub_blnShowHistoryRecords = this.reportParameters.ShowHistoryRecords;
 pub_blnShowOnlySelectedRecords = this.reportParameters.OnlySelectedRecords;
 pub_blnShowComments = this.reportParameters.ShowComments
 pub_blnShowCurrentAtndSteps = this.reportParameters.ShowCurrentAtndSteps;
 pub_blnIgnoreAttendance = this.reportParameters.IgnoreAttendance;
 pub_blnNotEnrolled = this.reportParameters.MarkNoEnrollment;
 pub_blnIncludeAllAbsences = this.reportParameters.IncludeAllAbsences;
 pub_blnConsecutiveDays = false;


*/